import { Injectable } from '@angular/core';
import { extend } from 'lodash';
import { ISearchParams } from '../../../entity-data/entity-data.data';

@Injectable()
export class EntityMasterBuilder {
  buildDefaultSearchParams(
    query: string,
    customInitialParams: ISearchParams
  ): ISearchParams {
    return extend(
      {},
      { query: query },
      !!customInitialParams ? customInitialParams : {}
    );
  }
}
